import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
  logout: () => api.post('/auth/logout'),
};

export const workspaceAPI = {
  create: (data) => api.post('/workspaces', data),
  getAll: () => api.get('/workspaces'),
  get: (workspaceId) => api.get(`/workspaces/${workspaceId}`),
  getMembers: (workspaceId) => api.get(`/workspaces/${workspaceId}/members`),
  getWriters: (workspaceId) => api.get(`/workspaces/${workspaceId}/writers`),
  addMember: (workspaceId, data) => api.post(`/workspaces/${workspaceId}/members`, data),
  updateMember: (workspaceId, memberId, data) => api.put(`/workspaces/${workspaceId}/members/${memberId}`, data),
  removeMember: (workspaceId, memberId) => api.delete(`/workspaces/${workspaceId}/members/${memberId}`),
  getAnalytics: (workspaceId) => api.get(`/workspaces/${workspaceId}/analytics`),
};

export const templateAPI = {
  create: (workspaceId, data) => api.post(`/workspaces/${workspaceId}/templates`, data),
  getAll: (workspaceId, targetField = null) => {
    const params = targetField ? `?target_field=${targetField}` : '';
    return api.get(`/workspaces/${workspaceId}/templates${params}`);
  },
  update: (workspaceId, templateId, data) => api.put(`/workspaces/${workspaceId}/templates/${templateId}`, data),
  delete: (workspaceId, templateId) => api.delete(`/workspaces/${workspaceId}/templates/${templateId}`),
};

export const articleAPI = {
  create: (data) => api.post('/articles', data),
  getAll: (workspaceId, search = null) => {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/workspaces/${workspaceId}/articles${params}`);
  },
  get: (articleId) => api.get(`/articles/${articleId}`),
  update: (articleId, data) => api.put(`/articles/${articleId}`, data),
  duplicate: (articleId) => api.post(`/articles/${articleId}/duplicate`),
  delete: (articleId) => api.delete(`/articles/${articleId}`),
  export: (articleId) => api.get(`/articles/${articleId}/export`),
  preview: (articleId) => api.get(`/articles/${articleId}/preview`),
};

export const blockAPI = {
  create: (articleId, data) => api.post(`/articles/${articleId}/blocks`, data),
  getAll: (articleId) => api.get(`/articles/${articleId}/blocks`),
  update: (articleId, blockId, data) => api.put(`/articles/${articleId}/blocks/${blockId}`, data),
  delete: (articleId, blockId) => api.delete(`/articles/${articleId}/blocks/${blockId}`),
  reorder: (articleId, blockIds) => api.put(`/articles/${articleId}/blocks/reorder`, { block_ids: blockIds }),
  addComment: (articleId, blockId, data) => api.post(`/articles/${articleId}/blocks/${blockId}/comments`, data),
  updateComment: (articleId, blockId, commentId, data) => api.put(`/articles/${articleId}/blocks/${blockId}/comments/${commentId}`, data),
  deleteComment: (articleId, blockId, commentId) => api.delete(`/articles/${articleId}/blocks/${blockId}/comments/${commentId}`),
};

export const notificationAPI = {
  getAll: () => api.get('/notifications'),
  markRead: (notificationId) => api.put(`/notifications/${notificationId}/read`),
  markAllRead: () => api.put('/notifications/read-all'),
};

export const billingAPI = {
  getPlan: () => api.get('/billing/plan'),
  getPlans: () => api.get('/billing/plans'),
  startTrial: () => api.post('/billing/start-trial'),
  createOrder: (data) => api.post('/billing/create-order', data),
  verifyPayment: (data) => api.post('/billing/verify-payment', data),
  getSubscription: () => api.get('/billing/subscription'),
  cancelSubscription: () => api.delete('/billing/subscription'),
  purchaseAddon: (data) => api.post('/billing/purchase-addon', data),
  verifyAddonPayment: (data) => api.post('/billing/verify-addon-payment', data),
};

export const permissionsAPI = {
  getCategories: () => api.get('/permissions'),
};

export default api;
